var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tipoDec)?_c('div',{staticClass:"row p-1 d-flex justify-content-center text-center tipo-dec"},[_c('b',[_vm._v("Declaración "+_vm._s(_vm.tipoDec?_vm.tipoDec:'')+" / "+_vm._s(_vm.anio? _vm.anio:''))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4300e010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TipoDec.vue
// module id = JViG
// module chunks = 6